import { Spinner, Button, Intent } from "@blueprintjs/core"
import { Dispatch, SetStateAction, useState } from "react"

import { SCIENT_COLORS } from "../../../../styled/scientColors"
import { FlexContainer } from "../../../../styled/flexbox.styled"
import { DataframeData, IAccountBookPairs, TradingBook } from "../types"
import { NoDataMessage } from "./Orders.styled"
import { SummaryContainer } from "./Summary.styled"
import LiveOrdersSwitch from "./components/LiveOrdersSwitch"
import SummaryGrid from "./components/SummaryGrid"
import PositionUploadDialog from "./components/PositionUploadDialog"

interface IPositionsProps {
  summary?: DataframeData
  books: TradingBook[]
  isLoading: boolean
  setSelectedFilters: Dispatch<SetStateAction<IAccountBookPairs>>
  selectedFilters: IAccountBookPairs
  setLiveOrders: Dispatch<SetStateAction<boolean>>
  isLiveOrders: boolean
}

const Summary = ({
  summary,
  books,
  isLoading,
  setSelectedFilters,
  selectedFilters,
  isLiveOrders,
  setLiveOrders,
}: IPositionsProps) => {
  const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false)

  return (
    <SummaryContainer
      alignItems="center"
      numberOfRows={summary?.rows.length}
      justifyContent="center"
      switchLabelColor={isLiveOrders ? SCIENT_COLORS.green5 : SCIENT_COLORS.orange5}
    >
      {summary ? (
        <SummaryGrid
          summary={summary}
          books={books}
          setSelectedFilters={setSelectedFilters}
          selectedFilters={selectedFilters}
          label={"Summary"}
        >
          <FlexContainer gap="15px" alignItems="center">
            <Button
              intent={Intent.PRIMARY}
              minimal
              onClick={() => setIsUploadDialogOpen(true)}
              text="Upload CSV"
            />
            <LiveOrdersSwitch setLiveOrders={setLiveOrders} isLiveOrders={isLiveOrders} />
          </FlexContainer>
        </SummaryGrid>
      ) : isLoading ? (
        <Spinner />
      ) : (
        <NoDataMessage>No portfolio summary available, please contact tech support</NoDataMessage>
      )}

      <PositionUploadDialog
        isOpen={isUploadDialogOpen}
        onClose={() => setIsUploadDialogOpen(false)}
      />
    </SummaryContainer>
  )
}

export default Summary
